export const GET_POKEMONS = 'GET_POKEMONS';
export const GET_POKEMON_DETAILS = 'GET_POKEMON_DETAILS';
export const CLEAR_DETAILS = 'CLEAR_DETAILS';
export const POST_POKEMON = 'POST_POKEMON';
export const GET_TYPES = 'GET_TYPES';
export const GET_POKEMON_NAME = 'GET_POKEMON_NAME';
export const SHOW_ERROR = 'SHOW_ERROR';
